import Session from "apollo/actions/session";
import axios from "@axiosConfig";

const POLLING_INTERVAL = 30 * 60000; // 30 minutes

const CheckSessionTimeoutPoller = () => {
    const logoutAction = () => {
        axios.patch("/users/me/log_out").then(() => {
            Session.signout(() => (window.location = "/"));
        }).catch((error) => {
            console.log(error);

            if (error.response.status === 401) {
                Session.signout(() => (window.location = "/"));
            }
        });
    }

    const checkLoggedIn = () => {
        axios.get("/users/me/check_logged_in").then((response) => {
            if (!response.data.logged_in) {
                logoutAction();
            }
        }).catch((error) => {
            // If get a 401 Unauthorized response:
            if (error.response.status === 401) {

                logoutAction();
            }
        });
    };

    setInterval(() => checkLoggedIn(), POLLING_INTERVAL);

    return null;
};

export default CheckSessionTimeoutPoller;
